import React, { Fragment, useMemo } from "react";
import styled from "styled-components";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid } from '@material-ui/core'
import { Headline, Placeholder, InnerGrid } from "../styled/FormComponents";
import { Field, Form } from "@progress/kendo-react-form";
import { Input } from '@progress/kendo-react-inputs'
import { DropDownField } from "../index";
import { getBusinessAreas, getMainCategories } from "../../services";
import { Button } from "@progress/kendo-react-buttons";

export default ({ onClose, onSubmit }) => {
  const mainCategories = useMemo(() => getMainCategories(), []);
  const businessAreas = useMemo(() => getBusinessAreas(), []);

  return (
    <Dialog title="Neues Projekt anlegen" onClose={onClose} minWidth="500px">
      <Headline>AMC Nummer</Headline>
      <Form
        onSubmit={onSubmit}
        render={(formRenderProps) => (
          <Fragment>
            <Grid container>
              <InnerGrid item md={6} xs={12}>
                <Field
                  name="mainCategory"
                  component={DropDownField}
                  label="Hauptgruppe"
                  data={mainCategories}
                />
                <Placeholder />
                <Field
                  name="businessArea"
                  component={DropDownField}
                  label="Bereich"
                  data={businessAreas}
                />
                <Placeholder />
              </InnerGrid>
              <InnerGrid item md={6} xs={12}>
                <Field
                  name="prospectNumber"
                  component={Input}
                  label="Prospekt Nummer"
                />
                <Placeholder />
              </InnerGrid>
              </Grid>
            <p>
              Eine neue Nummer wird anschließend automatisch vergeben
              <br />
              und kann im Bearbeitungsdialog gegebenenfalls geändert werden.
            </p>
            <StyledButton
              primary
              onClick={formRenderProps.onSubmit}
              disabled={
                (formRenderProps.valueGetter("mainCategory") === undefined ||
                formRenderProps.valueGetter("businessArea") === undefined) &&
                formRenderProps.valueGetter("prospectNumber") === undefined
              }
            >
              Anlegen
            </StyledButton>
            <StyledButton onClick={onClose}>Abbrechen</StyledButton>
          </Fragment>
        )}
      />
    </Dialog>
  );
};

const StyledButton = styled(Button)`
  margin-right: 15px;
`;



// WEBPACK FOOTER //
// ./src/components/dialog/NewProjectDialog.js